import { render, staticRenderFns } from "./NavigationTop.vue?vue&type=template&id=a64bd8e4&"
import script from "./NavigationTop.ts?vue&type=script&lang=ts&"
export * from "./NavigationTop.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationTop.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports